module.exports = __webpack_public_path__ + "static/media/login_icon.f6d2b47a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_icon.svg
// module id = 109
// module chunks = 0